module.exports = __webpack_public_path__ + "img/u864.615d88fe.png";